import React, { useState } from "react";

const LeiaMais = ({ children, content }) => {
  const [leiaMaisContent, setLeiaMaisContent] = useState("");

  return (
    <div>
      <div
        onClick={(e) => {
          setLeiaMaisContent(children);
          e.target.innerHTML = "";
        }}
      >
        <div className="titulo2">{content}</div>
      </div>

      {leiaMaisContent}
    </div>
  );
};

export default LeiaMais;
